var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styles } from './input.styles';
export function getVariantClasses(props) {
    var _a;
    var variant = props.variant || 'outlined';
    if (props.filled)
        variant = 'filled';
    else if (props.bordered)
        variant = 'bordered';
    else if (props.borderless)
        variant = 'borderless';
    else if (props.solo)
        variant = 'solo';
    else if (props.outlined)
        variant = 'outlined';
    return _a = {},
        _a[styles.variants[variant]] = true,
        _a;
}
export function getSizeClasses(props) {
    var _a;
    var size = props.size || 'medium';
    if (props.small)
        size = 'small';
    else if (props.medium)
        size = 'medium';
    else if (props.large)
        size = 'large';
    return _a = {},
        _a[styles.sizes[size]] = true,
        _a;
}
export function getAlignClasses(props) {
    var _a;
    var align = props.align || 'left';
    if (props.left)
        align = 'left';
    else if (props.center)
        align = 'center';
    else if (props.right)
        align = 'right';
    return _a = {},
        _a[styles.aligns[align]] = true,
        _a;
}
export function getInputBaseProps() {
    return {
        autoCapitalize: 'none',
        autoComplete: 'off',
        autoCorrect: 'off',
        formNoValidate: true,
        spellCheck: 'off',
        type: 'text',
    };
}
export function cleanProps(_a) {
    var bordered = _a.bordered, borderless = _a.borderless, filled = _a.filled, large = _a.large, medium = _a.medium, outlined = _a.outlined, size = _a.size, small = _a.small, variant = _a.variant, solo = _a.solo, clearable = _a.clearable, onBlur = _a.onBlur, onChange = _a.onChange, onChangeValue = _a.onChangeValue, onFocus = _a.onFocus, value = _a.value, onClear = _a.onClear, prefix = _a.prefix, suffix = _a.suffix, hint = _a.hint, label = _a.label, onSearch = _a.onSearch, search = _a.search, canSearch = _a.canSearch, panel = _a.panel, panelContent = _a.panelContent, panelLabel = _a.panelLabel, clearableOnEscape = _a.clearableOnEscape, delayed = _a.delayed, loading = _a.loading, noDelayed = _a.noDelayed, onEnterDown = _a.onEnterDown, onEnterUp = _a.onEnterUp, onEscapeDown = _a.onEscapeDown, onEscapeUp = _a.onEscapeUp, onPasswordVisible = _a.onPasswordVisible, disabled = _a.disabled, readOnly = _a.readOnly, password = _a.password, passwordVisible = _a.passwordVisible, selectAllOnFocus = _a.selectAllOnFocus, error = _a.error, errored = _a.errored, onValidate = _a.onValidate, onValidateError = _a.onValidateError, validate = _a.validate, validateMode = _a.validateMode, chevron = _a.chevron, height = _a.height, onClickAway = _a.onClickAway, width = _a.width, align = _a.align, center = _a.center, contentLeft = _a.contentLeft, contentRight = _a.contentRight, inputStyle = _a.inputStyle, left = _a.left, right = _a.right, action = _a.action, actionEnable = _a.actionEnable, onAction = _a.onAction, actionColor = _a.actionColor, actionTextColor = _a.actionTextColor, initialValue = _a.initialValue, rest = __rest(_a, ["bordered", "borderless", "filled", "large", "medium", "outlined", "size", "small", "variant", "solo", "clearable", "onBlur", "onChange", "onChangeValue", "onFocus", "value", "onClear", "prefix", "suffix", "hint", "label", "onSearch", "search", "canSearch", "panel", "panelContent", "panelLabel", "clearableOnEscape", "delayed", "loading", "noDelayed", "onEnterDown", "onEnterUp", "onEscapeDown", "onEscapeUp", "onPasswordVisible", "disabled", "readOnly", "password", "passwordVisible", "selectAllOnFocus", "error", "errored", "onValidate", "onValidateError", "validate", "validateMode", "chevron", "height", "onClickAway", "width", "align", "center", "contentLeft", "contentRight", "inputStyle", "left", "right", "action", "actionEnable", "onAction", "actionColor", "actionTextColor", "initialValue"]);
    return rest;
}
